module.exports = __webpack_public_path__ + "img/TelefonicaWeb-RegularItalic.0284d958.svg";